var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#E86717",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0625 26.0001V26C37.0625 23.812 36.4137 21.6732 35.1981 19.854C33.9826 18.0348 32.2548 16.6169 30.2334 15.7796C28.212 14.9423 25.9877 14.7232 23.8418 15.1501C21.6959 15.5769 19.7248 16.6305 18.1776 18.1776C16.6305 19.7248 15.5769 21.6959 15.1501 23.8418C14.7232 25.9877 14.9423 28.212 15.7796 30.2334C16.6169 32.2548 18.0348 33.9826 19.854 35.1981C21.6732 36.4137 23.812 37.0625 26 37.0625H26.0001C28.933 37.0592 31.7448 35.8926 33.8187 33.8187C35.8926 31.7448 37.0592 28.933 37.0625 26.0001ZM38.9375 26.0001C38.9375 28.5588 38.1787 31.0601 36.7571 33.1877C35.3356 35.3152 33.315 36.9735 30.951 37.9527C28.587 38.9319 25.9857 39.1881 23.476 38.6889C20.9664 38.1897 18.6612 36.9575 16.8518 35.1482C15.0425 33.3389 13.8103 31.0336 13.3111 28.524C12.8119 26.0144 13.0681 23.4131 14.0473 21.049C15.0265 18.685 16.6848 16.6645 18.8123 15.2429C20.9399 13.8213 23.4412 13.0625 26 13.0625C29.4301 13.0661 32.7187 14.4304 35.1442 16.8558C37.5697 19.2813 38.9339 22.5699 38.9375 26.0001Z",
    fill: "#E86717",
    stroke: "#E86717",
    strokeWidth: 0.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21V30",
    stroke: "#E86717",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21V30",
    stroke: "#E86717",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHold);
export default __webpack_public_path__ + "static/media/OnHold.c175d703f6fb43df6f738c3a5009aef8.svg";
export { ForwardRef as ReactComponent };